"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Step = _interopRequireDefault(require("./components/Step"));

var _constants = require("./constants");

var _utils = require("./utils");

var _StepperSt = require("./Stepper.st.css");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Stepper/Stepper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Stepper */
var Stepper = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Stepper, _React$PureComponent);

  var _super = _createSuper(Stepper);

  function Stepper() {
    var _this;

    (0, _classCallCheck2["default"])(this, Stepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getActiveStepType", function () {
      var _this$props = _this.props,
          activeStep = _this$props.activeStep,
          steps = _this$props.steps;
      var step = steps[activeStep];
      return step.type !== _constants.StepType.Disabled ? step.type : undefined;
    });
    return _this;
  }

  (0, _createClass2["default"])(Stepper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dataHook = _this$props2.dataHook,
          steps = _this$props2.steps,
          type = _this$props2.type,
          fit = _this$props2.fit,
          activeStep = _this$props2.activeStep,
          onClick = _this$props2.onClick;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _StepperSt.st)(_StepperSt.classes.root, {
          fit: fit
        }),
        "data-hook": dataHook,
        "data-type": type,
        "data-fit": fit,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 7
        }
      }, steps.map(function (step, index) {
        var isLastStep = index === steps.length - 1;
        var isActiveStep = index === activeStep;
        return /*#__PURE__*/_react["default"].createElement(_Step["default"], (0, _extends2["default"])({}, step, {
          key: index,
          number: index + 1,
          active: isActiveStep,
          last: isLastStep,
          type: isActiveStep ? _this2._getActiveStepType() : step.type,
          styleType: type,
          onClick: onClick && function () {
            return onClick(index);
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 68,
            columnNumber: 13
          }
        }));
      }));
    }
  }]);
  return Stepper;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Stepper, "displayName", 'Stepper');
(0, _defineProperty2["default"])(Stepper, "propTypes", {
  /** Hook for testing purposes. */
  dataHook: _propTypes["default"].string,

  /** Event triggered on step click: `onClick(stepIndex)` */
  onClick: _propTypes["default"].func,

  /** Index of the active step. */
  activeStep: _propTypes["default"].number.isRequired,

  /**
   * An array of steps, where each step is an object with the following properties:
   * - `text` - step title text (required).
   * - `type` - step type (`completed`, `disabled`, `error` or default `normal`).
   */
  steps: _utils.validateStepsPropType,

  /** Style type. */
  type: _propTypes["default"].oneOf(['circle', 'text']),

  /**
   * Fit mode for steps. In `stretched` mode the component will grow to fill parent
   * container width.
   */
  fit: _propTypes["default"].oneOf(['compact', 'stretched'])
});
(0, _defineProperty2["default"])(Stepper, "defaultProps", {
  steps: [],
  type: 'circle',
  fit: 'compact'
});
var _default = Stepper;
exports["default"] = _default;
//# sourceMappingURL=Stepper.js.map